/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button,
    Heading,
    Icon,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    SimpleGrid,
    VStack,
    useToast,
    Select,
    FormControl,
    FormLabel,
    HStack
  } from '@chakra-ui/react'
  import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
  import { SubmitHandler, useForm } from 'react-hook-form'
  import { RiAddLine } from 'react-icons/ri'
  import { v4 as uuid } from 'uuid'
  import {
    IHouseProps,
    IItemProps,
    IItemType,
    IOptionProps,
    multiOptionsConcierge,
    typeOptionsConcierge,
    useConcierge
  } from '../../../Hooks/Concierge'
  import { ITEMS_MULTI, ITEMS_TYPE } from '../../../Services/contants'
  import { ConciergeOptionContent } from '../../Concierge/ConciergeOptionContent'
  import { Input } from '../../Form/Input'
  import { type } from 'os'
  import { options } from '@fullcalendar/core/preact'
import { generateYearOptions } from '../../../utils/generateYearOptions'
import api from '../../../Services/api'
import { IQuotasProperty } from '../../../interfaces/IQuotasProps'
  
  interface Props {
    onClose: (data?: any) => void
    type: "ADD" | "REMOVE"
    user_id: string
    userType: string | undefined
  }
  
  const BalanceMovimentationModal: FC<Props> = ({ onClose, type, user_id, userType }) => {
    const [loading, setLoading] = useState(false)
    const [origin, setOrigin] = useState<'CLUB' | 'HOMES' | undefined>(undefined)
    const [year, setYear] = useState(() => {
        const today = new Date()
        return String(today.getFullYear())
      })
    const [properties, setProperties] = useState<{ value: string; label: string; bookingYears: number[] }[]>([])
    const [propertySelected, setPropertySelected] = useState<string | undefined>(undefined)
    
    const originOptions = [
      { label: 'Club', value: 'CLUB' },
      { label: 'Homes', value: 'HOMES' }
    ]

    // Para HOMES com casa selecionada, a competência segue os anos liberados da casa
    const yearOptions = useMemo(() => {
      const property = properties.find(i => i.value === propertySelected)

      if (origin === 'HOMES' && property?.bookingYears?.length) {
        return property.bookingYears.map(y => ({ label: String(y), value: String(y) }))
      }

      return generateYearOptions()
    }, [origin, properties, propertySelected])

    useEffect(() => {
      if (yearOptions.some(i => i.value === year)) return

      const currentYear = String(new Date().getFullYear())
      setYear(yearOptions.some(i => i.value === currentYear) ? currentYear : yearOptions[0]?.value ?? '')
    }, [yearOptions, year])

    const toast = useToast()

  
    const { register, handleSubmit, formState, setValue, watch, unregister } =
      useForm({
        // resolver: yupResolver(createFormSchema)
      })
  

    const handleAction: SubmitHandler<any> = useCallback(
      async (values) => {
        setLoading(true)
        try {

          if(!origin){
            toast({
              title: 'Selecione uma origem',
              position: 'top',
              isClosable: true,
              status: 'error',
              variant: 'solid'  
            })
            return
          }

          if(origin === 'HOMES' && !propertySelected){
            toast({
              title: 'Selecione uma casa',
              position: 'top',
              isClosable: true,
              status: 'error',
              variant: 'solid'  
            })
            return
          }

            const payload = {
                user_id,
                credits: values.credits,
                year,
                origin,
                property_id: propertySelected
            }

            if(type === 'ADD'){
                await api.post(`/balance`, payload)
            } else {
                await api.delete(`/balance`, { params: {
                    ...payload
                }} )
            }
            
            toast({
                title: 'Operação realizada com sucesso',
                position: 'top',
                isClosable: true,
                status: 'success',
                variant: 'solid'
              })
          onClose()
        } catch (error) {
          toast({
            title: error.response.data.message,
            position: 'top',
            isClosable: true,
            status: 'error',
            variant: 'solid'
          })
          setLoading(false)
        }
      },
      [
        toast,
        propertySelected,
        origin,
        user_id,
        type,
        year
      ]
    )

    const loadQuotas = useCallback(async () => {
      try {
        setLoading(true);
        const {data} = await api.get('/quotas', {
          params: {
            user_id,
            pag: 1,
            all: true,
          },
        });
  
        const propertiesFiltered: IQuotasProperty[] = [];
        const quotaIdsAdicionados = new Set();
  
        data?.data?.forEach((item: IQuotasProperty) => {
          if (!quotaIdsAdicionados.has(item.property_id)) {
            propertiesFiltered.push(item);
            quotaIdsAdicionados.add(item.property_id);
          }
        });
  
        const normalize = propertiesFiltered
          ?.map((item: IQuotasProperty) => ({
            value: item.property?.id,
            label: item.property?.name,
            bookingYears: item.property?.available_booking_years ?? []
          }))
          .filter((item): item is { value: string; label: string; bookingYears: number[] } => 
            typeof item.value === 'string' && typeof item.label === 'string'
          );
  
        if (!normalize?.length) {
          toast({
            title: 'O seu usuário não possui nenhuma cota de casa disponível. Atribua o sócio em uma casa no menu CASAS.',
            position: 'top',
            isClosable: true,
            status: 'error',
            variant: 'solid'
          })
          return;
        }

        setProperties(normalize)
  
     
      } catch (error) {
        console.log('loadQuotas error: ', error);
      } finally {
        setLoading(false);
      }
    }, [user_id, toast]);

    useEffect(() => {
      if(userType === 'HOMES' || userType === 'HOMESCLUB'){
        loadQuotas()
      }
    }, [userType])
  
  

  

    return (
      <>
        <Modal isOpen onClose={onClose} size="6xl">
          <ModalOverlay />
          <Box
            as="form"
            flex="1"
            borderRadius={8}
            bg="white"
            p="8"
            onSubmit={handleSubmit(handleAction)}
          >
            <ModalContent>
              <ModalHeader mb="0" pb="0">
                {type === "ADD" ? "Adicionar Créditos" : "Remover Créditos"}
              </ModalHeader>
  
              <ModalCloseButton />
  
              <ModalBody mt='20px'>
              
              <VStack spacing={['6', '8']}>
                <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">
                  <FormControl>
                        <FormLabel>Origem</FormLabel>
                        <Select w={300} placeholder='Origem' onChange={(e:any) => setOrigin(e.target.value)} defaultValue={origin} value={origin}>
                          {originOptions?.map(i => <option key={i.value} value={i.value}>{i.label}</option>)}
                        </Select>
                  </FormControl>
                  </SimpleGrid>

                  {origin === 'HOMES' && properties?.length > 0 && ( <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">

                 
                    <FormControl>
                      <FormLabel>Casa</FormLabel>
                      <Select w={400} placeholder='Casa' onChange={e => setPropertySelected(e.target.value)} defaultValue={propertySelected} value={propertySelected}>
                        {properties?.map(i => <option key={i.value} value={i.value}>{i.label}</option>)}
                      </Select>
                    </FormControl>
                 
                  </SimpleGrid>  )}

                  {!!origin && ( <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">

                
                      <FormControl>
                      <FormLabel>Competência</FormLabel>
                      <Select w={100} placeholder='Competência' onChange={e => setYear(e.target.value)} defaultValue={year} value={year}>
                        {yearOptions?.map(i => <option key={i.value} value={i.value}>{i.value}</option>)}
                      </Select>
                    </FormControl> 
                  
                </SimpleGrid>  )}

              </VStack>

              <VStack spacing={['6', '8']} mt='20px'>
                <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">
                 

                    {!!origin && (
                      <Input
                      label="Créditos"
                      placeholder="Ex: 100"
                      // errors={errors.name}
                      {...register(`credits`)}
  
                    />     
                    )} 
                </SimpleGrid>
              </VStack>

             

           
               
              </ModalBody>
  
              <ModalFooter mt='20px'>
                <Button variant="ghost" mr={3} onClick={onClose}>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  bg="green.dark"
                  _hover={{ bgColor: 'green.teal' }}
                  color="green.light"
                  isLoading={formState.isSubmitting}
                >
                  Salvar
                </Button>
                {/* <Button variant='ghost' onClick={handeCreateNewData}>Cadastrar</Button> */}
              </ModalFooter>
            </ModalContent>
          </Box>
        </Modal>
      </>
    )
  }
  
  export { BalanceMovimentationModal }
  